import React from 'react';
import { ScrollToSiteContext } from 'core/components/ScrollToSite';


export default function disableOnScrollToSite(WrappedComponent) {
  return function ScrollToSiteComponent(props) {
    return (
      <ScrollToSiteContext.Consumer>
        {({ isScrollToSite }) => {
          if (isScrollToSite) return null;
          return (
            <WrappedComponent {...props} />
          );
        }}
      </ScrollToSiteContext.Consumer>
    );
  };
}
